// DiscoverAction — client-side capability gates fed to <Policy>/usePolicyContext.
// Coarse role capabilities only; community (subject) scope is a BE concern and is NOT gated here.
export var DiscoverAction;
(function (DiscoverAction) {
    DiscoverAction["ManageUsers"] = "MANAGE_USERS";
    DiscoverAction["DeleteUser"] = "DELETE_USER";
    DiscoverAction["ManageBilling"] = "MANAGE_BILLING";
    DiscoverAction["ManageAssessments"] = "MANAGE_ASSESSMENTS";
    DiscoverAction["ViewAdminDashboard"] = "VIEW_ADMIN_DASHBOARD";
})(DiscoverAction || (DiscoverAction = {}));
export const ALL_DISCOVER_ACTIONS = Object.values(DiscoverAction);
// Org Admin (discover_admin) capabilities within their own org. No cross-org admin dashboard,
// no hard-delete — those stay Peek-admin only (see generateAllowedActions).
export const ORG_ADMIN_ACTIONS = [
    DiscoverAction.ManageUsers,
    DiscoverAction.ManageBilling,
    DiscoverAction.ManageAssessments,
];
// Demo (discover_demo) — externally shared sales sandbox. Sees the org-level settings surfaces
// for the pitch, but never the Peek-admin-only or cross-org actions (DeleteUser,
// ViewAdminDashboard) and never assessment authoring (demo is already blocked from creating
// reports on the home page).
export const DEMO_ACTIONS = [DiscoverAction.ManageUsers, DiscoverAction.ManageBilling];
